export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
export const SET_DATE_RANGE = 'SET_DATE_RANGE';

export const setSearchValue = (value) => ({
  type: SET_SEARCH_VALUE,
  payload: value,
});

export const setDateRange = (range) => ({
  type: SET_DATE_RANGE,
  payload: range,
});
